import { 
    FETCH_JOKE_PENDING,
    FETCH_JOKE_SUCCESS,
    FETCH_JOKE_FAILED 
} from './types'

import chuckNorris from '../apis/chuckNorris'

export const fetchJoke = () => {
    return async (dispatch) => {
        try { 
            dispatch({ type: FETCH_JOKE_PENDING })
            const response = await chuckNorris.get(`/jokes/random`)
            dispatch({ type: FETCH_JOKE_SUCCESS, payload: response.data.value })
        } catch(error) {
            dispatch({ type: FETCH_JOKE_FAILED, payload: error })
        }
    }
}